import { render, staticRenderFns } from "./CorestreamLandingPage.vue?vue&type=template&id=31dc6d76"
import script from "./CorestreamLandingPage.vue?vue&type=script&lang=js"
export * from "./CorestreamLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports